import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getAgreementInitialValues } from './utils';

import type { RootState } from '../../../../../../../store';

export default function useAgreementInitialValues() {
  const agreement = useSelector(
    (state: RootState) => state.onboardingQuestionnaire.onboardingQuestionnaireDetails?.agreement,
  );
  const providerFullName = useSelector(
    (state: RootState) =>
      state.onboardingQuestionnaire.onboardingQuestionnaireDetails?.general_info
        ?.provider_full_name ?? '',
  );

  return useMemo(
    () => getAgreementInitialValues(agreement, providerFullName),
    [agreement, providerFullName],
  );
}
